import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../shared/loading/loading.service';
import { Router } from '@angular/router';

@Component({
  selector: 'brix-forgot-password',
  template: require('./okta-forgot-password.template.html'),
  styles: [require('./okta-forgot-password.stylesheet.scss'), require('../shared/styles/form.scss')]
})
export class OktaForgotPassword implements OnInit {

  constructor(
    private loadingService: LoadingService,
    private router: Router) {
  }

  ngOnInit() {
    this.loadingService.hideLoading();
  }
  gotoLogin() {
    this.router.navigate(['/login']);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/okta-forgot-password/okta-forgot-password.component.ts